
import TitleBox from '@/components/CSS/TitleBox'
import defaultSettings from '@/settings'
import { mapGetters } from 'vuex'
import { setHistoryList } from '@/utils/validate'
// import { customerList } from "@/api/common";
import GOODS_TYPE from '@/enum'
import getPageTitle from '@/utils/get-page-title'

export default {
	components: {
		TitleBox
	},
	data() {
		return {
			RECOVERY: false,
			defaultSettings,
			titleBoxName: null,
			linkType: null,
			historyName: 'servicesHistory', // 历史记录名字
			loading: true,
			action: {
				gameCatalogueId: null,
				firstChar: null,
				goodsCatalogueId: null
			},
			gameData: [],
			gameName: null,
			showService: false,
			historyData: [],
			gameCate: [
				{
					label: '全部游戏',
					value: null
				},
				{
					label: '端游',
					value: 1
				},
				{
					label: '手游',
					value: 2
				}
			],
			alphabet: [],
			goodsType: null,
			search: ''
		}
	},
	head() {
		return {
			title: this.RECOVERY ? `${getPageTitle('快速回收')}` : `${getPageTitle('联系' + this.titleBoxName || '客服')}`
		}
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			gameList: 'game/gameList',
			gameCateList: 'game/gameCateList',
			goodsTypeCateList: 'game/goodsTypeCateList'
		}),
		gameCateListForAllText() {
			return [{ id: null, name: '全部游戏' }, ...this.gameCateList]
		},
		gameListByFilter() {
			return this.gameData.filter(item => {
				return item.name.indexOf(this.search) !== -1
			})
		}
	},
	methods: {
		copySuccess() {
			this.$message.success('已复制')
		},
		async getService(item) {
			//4.2.2不再跳转咨询客服列表
			let history = {
				goodsCatalogueId: this.action.goodsCatalogueId,
				...item
			}
			setHistoryList(history, this.historyName)
			const res = await this.$api.getCustomerService({
				action: {
					gameId: item.id,
					goodsCatalogueId: this.action.goodsCatalogueId,
					linkType: 'GAME_CONSULT'
				}
			})
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			const imId = res.data?.id || null
			if (!imId) {
				this.$message.error('该游戏暂无客服')
				return
			}
			this.$store.commit('ry/SET_CONVERSATION_ACTIVE', 0)
			this.$store.dispatch('ry/join', { targetId: imId.toString(), conversationType: 1 })
			this.$store.commit('ry/SET_ORDER_FLOW_SHOW', false)
			this.$store.commit('ry/SET_ORDER_FLOW', [])
		},
		getGoodsType(item) {
			this.action.goodsCatalogueId = item.id
			this.getHistoryList()
			this.getGameList(this.action)
		},
		// 游戏类型栏目
		getGameDataByValue(value) {
			this.action.gameCatalogueId = value
			this.getGameList(this.action)
		},
		// 通过首字母获取游戏列表
		onClickAlphabet(val) {
			if (val === '全部') {
				this.action.firstChar = null
			} else {
				this.action.firstChar = val
			}
			this.getGameList(this.action)
		},
		getGameList() {
			this.loading = true
			const data = { action: this.action }
			this.$api.gameAll(data).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.loading = false
				this.gameData = res.data
			})
		},
		getHistoryList() {
			if (window.localStorage.getItem(this.historyName) && window.localStorage.getItem(this.historyName) !== '[""]') {
				let historyData = JSON.parse(window.localStorage.getItem(this.historyName))
				if (!historyData.length) return
				// let _arr = [];
				// historyData.map((item) => {
				//     this.gameList.map((element) => {
				//         if (item.id === element.id) {
				//
				//             _arr.push(item);
				//         }
				//     });
				// });
				this.historyData = historyData.filter(item => item.goodsCatalogueId == this.action.goodsCatalogueId || GOODS_TYPE.ACCOUNT)
			}
		}
	},
	async mounted() {
		for (let i = 0; i < 26; i++) {
			this.alphabet.push(String.fromCharCode(65 + i))
		}
		this.alphabet.unshift('全部')
		await this.$store.dispatch('game/GoodsTypeCateList')
		this.action.goodsCatalogueId = this.goodsTypeCateList[0] && this.goodsTypeCateList[0].id

		this.historyData = []
		this.linkType = this.$route.query.linkType
		this.titleBoxName = this.$route.query.linkType === 'RECOVERY' ? '' : '客服'
		if (this.$route.query.linkType === 'RECOVERY') {
			this.RECOVERY = true
		}
		if (this.$route.query.linkType) {
			this.historyName = `servicesHistory-${this.$route.query.linkType}`
		}
		this.historyName = 'servicesHistory'
		this.getGameList()
		this.getHistoryList()
	}
}
